export type CartMergeAction =
  | { type: "none" }
  | { type: "adopt"; targetCartId: string }
  | { type: "merge"; sourceCartId: string; targetCartId: string };

type ResolveCartMergeActionParams = {
  sourceCartId?: string | null;
  hasSourceItems: boolean;
  targetCartId?: string | null;
};

/**
 Function that determines what to do with the cart after logging in
 */
export const resolveCartMergeAction = ({
  sourceCartId,
  hasSourceItems,
  targetCartId,
}: ResolveCartMergeActionParams): CartMergeAction => {
  // No target cart: nothing to merge into — stay with the current cart
  if (!targetCartId) {
    return { type: "none" };
  }

  // No real source cart (no id or empty id without items) — nothing to merge, so adopt the user's cart
  if (!(sourceCartId && hasSourceItems)) {
    return { type: "adopt", targetCartId };
  }

  // Source and target carts are the same — do nothing
  if (sourceCartId === targetCartId) {
    return { type: "none" };
  }

  return { type: "merge", sourceCartId, targetCartId };
};
